import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reno-cup-brackets',
  templateUrl: './reno-cup-brackets.component.html',
  styleUrls: ['./reno-cup-brackets.component.css']
})
export class RenoCupBracketsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
